import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Designation } from "../models/designation"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class DesignationService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'designation/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllDesignation(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Designation>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllDesignation?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewDesignation(DesignationID?: string): Observable<Array<Designation>> {
    return this.httpService.get(this.apiEndpoint + 'viewDesignation/' + (DesignationID ? DesignationID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveDesignation(designations: Designation): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveDesignation/', designations).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkEmail(Emailid?: string, DesignationId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&DesignationId=' + (DesignationId ? DesignationId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      return result;
    })); 
  }

  deleteDesignation(DesignationID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteDesignation/' + (DesignationID ? DesignationID : '00000000-0000-0000-0000-000000000000'), DesignationID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(DesignationName?: string,DesignationId?: string,Code?:string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?DesignationName=' + (DesignationName ? DesignationName : '')+ '&DesignationId=' + (DesignationId ? DesignationId : '00000000-0000-0000-0000-000000000000')+'&Code=' + (Code ? Code : '')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
